import axios from 'axios';
import toast from 'react-hot-toast';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Request interceptor - attach access token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Response interceptor - handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const isAuthRoute = originalRequest.url?.includes('/auth/login') ||
  originalRequest.url?.includes('/auth/register');

if (error.response?.status === 401 && !originalRequest._retry && !isAuthRoute) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
    const response = await axios.post(
  `${API_BASE_URL}/auth/refresh-token`,
  {},
  {
    withCredentials: true
  }
);
    const { accessToken } = response.data.data;

localStorage.setItem('accessToken', accessToken);

api.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

// Update the retry request
originalRequest.headers = originalRequest.headers || {};
originalRequest.headers.Authorization = `Bearer ${accessToken}`;

processQueue(null, accessToken);

return api(originalRequest);
     } catch (refreshError) {
  processQueue(refreshError, null);
  isRefreshing = false;
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  window.dispatchEvent(new Event('auth:logout'));
  return Promise.reject(refreshError);
} finally {
  isRefreshing = false;
}
    }

    return Promise.reject(error);
  }
);

export default api;
